import { Box } from '@src/atoms/Box';
import { DatePicker } from '@src/atoms/DatePicker';
import React, { FC, useCallback, useState } from 'react';
import { FilterSwipeDialogWrapper } from '../_Wrapper/FilterSwipeDialogWrapper';
import { DISPLAY_FORMAT } from './consts';

import styles from './FiltersSwipeDialogDateRangeItem.scss';

interface IFiltersSwipeDialogDateProps {
  value?: string | null;
  title: string;
  name: string;
  label: string;
  onClose: () => void;
  onSubmit: (value?: string | null) => void;
}

export const FiltersSwipeDialogDateRangeItem: FC<IFiltersSwipeDialogDateProps> = ({
  name,
  title,
  label,
  onClose,
  onSubmit,
  value: propsValue,
}) => {
  const [value, setValue] = useState<string | null | undefined>(propsValue);

  const handleSubmit = useCallback(() => {
    onSubmit(value);
  }, [onSubmit, value]);

  return (
    <FilterSwipeDialogWrapper title={title} resultText="Применить" onBack={onClose} onSubmit={handleSubmit}>
      <Box padding={16} fullWidth gap={16} column alignItems="center">
        <DatePicker
          id={name}
          format={DISPLAY_FORMAT}
          postIcon="calendar"
          label={label}
          open={false}
          value={value || ''}
          isClearable
          onChange={setValue}
        />

        <DatePicker
          id={name}
          format={DISPLAY_FORMAT}
          postIcon="calendar"
          open={true}
          value={value || ''}
          inline
          onChange={setValue}
          className={styles.calendar}
          calendarClassName={styles.root}
        />
      </Box>
    </FilterSwipeDialogWrapper>
  );
};
